// extracted by mini-css-extract-plugin
module.exports = {"container":"Invoices_container__YGnC-","backButton":"Invoices_backButton__3prab"};